import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: ${({ width }: any) => width + 'px'};
  height: ${({ height }: any) => height + 'px'};
  color: #da4848;
`

// TODO Remove width/height props, use styles or classes
const Error = ({
  title = 'Error',
  width = 64,
  height = 64,
  ...rest
}: IconProps & { width?: number; height?: number }) => (
  // @ts-expect-error
  <StyledIcon viewBox="0 0 64 64" width={width} height={height} title={title} {...rest}>
    <g fill="currentColor" strokeLinecap="square">
      <path fill="none" stroke="currentColor" strokeWidth={2} strokeMiterlimit={10} d="M4 60L32 8l28 52z" />
      <path fill="none" stroke="currentColor" strokeWidth={2} strokeMiterlimit={10} d="M32 28v15" />
      <circle fill="none" stroke="currentColor" strokeWidth={2} strokeMiterlimit={10} cx={32} cy={50} r={1} />
      <circle cx={32} cy={50} r={1} />
    </g>
  </StyledIcon>
)

Error.displayName = 'Error'
Error.needsWork = true
export default Error
